module.exports = __webpack_public_path__ + "static/media/tsb5ru.8b5c9cd3.pdf";